import { AzureAccessTierType } from 'mbs-ui-shared@models';
import { GlacierRestoreTiers } from 'wizards/models/base/base-models/plan-glacier-restor-tiers-model';
import { RestoreType } from 'wizards/models/restore-point-models';
import { RehydratePriority } from './plan-rehydrate-priority-model';
import { DeletePlan } from './plan-restore-delete-plan-model';
import { RestorePlanType } from './plan-restore-plan-type-model';

export class BaseRestorePlan {
  public UseHistory: boolean;
  public PeakRetrievalRateLimit: number | string;
  public RehydratePriority: RehydratePriority;
  public AccessTier: AzureAccessTierType;
  public KeepRestoredColdFilesDaysCount: number;
  public GlacierRestoreTier: GlacierRestoreTiers;
  public LimitRestore: boolean;
  public DeletePlan: DeletePlan;
  public PointInTimeUTC: Date | string;
  public PointInTime: Date | string;
  public RestoreSourcePrefix: string;
  public RestoreType: RestoreType;
  public RestorePlanType: RestorePlanType;
  public IsRestoreLatestVersion: boolean;
  public IsPlanCanBeRunnedWithoutLicense: boolean;
}
